import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'react-tippy';
import { connect } from 'react-redux';

import Button from 'Components/layout/Button';

@connect(
    (state) => ({
        purchasePhotosPolicy: state.user.currentPolicies.purchasePhotos
    }), {}
)
export default class GalleryControlsV2 extends React.Component {
    static propTypes = {
        purchasePhotosPolicy: PropTypes.bool.isRequired,
        mode: PropTypes.oneOf(['default', 'preview']),
        exclude: PropTypes.arrayOf(
            PropTypes.string
        ),
        photo: PropTypes.shape({
            id: PropTypes.string.isRequired,
            downloadUrl: PropTypes.string,
            imageCompUrl: PropTypes.string,
            controls: PropTypes.shape({
                curate: PropTypes.shape({
                    visible: PropTypes.bool,
                    trigger: PropTypes.func
                }),
                openInNewTab: PropTypes.shape({
                    visible: PropTypes.bool,
                    href: PropTypes.string
                }),
                open: PropTypes.shape({
                    visible: PropTypes.bool,
                    trigger: PropTypes.func
                }),
                buy: PropTypes.shape({
                    visible: PropTypes.bool,
                    trigger: PropTypes.func
                }),
                addToCart: PropTypes.shape({
                    visible: PropTypes.bool,
                    trigger: PropTypes.func
                }),
                addToLightbox: PropTypes.shape({
                    visible: PropTypes.bool,
                    trigger: PropTypes.func
                }),
                removeFromLightbox: PropTypes.shape({
                    visible: PropTypes.bool,
                    trigger: PropTypes.func
                }),
                star: PropTypes.shape({
                    visible: PropTypes.bool,
                    trigger: PropTypes.func
                }),
                unstar: PropTypes.shape({
                    visible: PropTypes.bool,
                    trigger: PropTypes.func
                }),
                addToCollection: PropTypes.shape({
                    visible: PropTypes.bool,
                    trigger: PropTypes.func
                }),
                removeFromCollection: PropTypes.shape({
                    visible: PropTypes.bool,
                    trigger: PropTypes.func
                }),
                reject: PropTypes.shape({
                    visible: PropTypes.bool,
                    trigger: PropTypes.func
                }),
                unreject: PropTypes.shape({
                    visible: PropTypes.bool,
                    trigger: PropTypes.func
                }),
                promote: PropTypes.shape({
                    visible: PropTypes.bool,
                    trigger: PropTypes.func
                }),
                demote: PropTypes.shape({
                    visible: PropTypes.bool,
                    trigger: PropTypes.func
                })
            })
        }).isRequired
    };
    static defaultProps = {
        exclude: [],
        mode: 'default'
    };

    presets = {
        curate: {
            className: 'curate-btn',
            icon: 'fa-info-circle',
            tip: 'Curate',
            href: `${process.env.ADMIN_URL}/curated_photos/new?photo_id=${this.props.photo.id}`,
            target: '_blank'
        },
        openInNewTab: {
            className: 'openInNewCart-btn',
            icon: 'fa-external-link',
            tip: 'Open in new tab'
        },
        buy: {
            className: 'openInNewCart-btn',
            icon: 'fa-shopping-cart',
            tip: 'Buy'
        },
        zoom: {
            className: 'zoom-btn',
            icon: 'fa-search-plus',
            tip: 'Zoom'
        },
        addToCart: {
            className: 'add-to-cart-btn',
            icon: 'fa-shopping-cart',
            tip: 'Add to cart'
        },
        addToLightbox: {
            className: 'add-to-lightbox-btn',
            icon: 'fa-lightbulb-o',
            tip: 'Add to lightbox'
        },
        removeFromLightbox: {
            className: 'remove-from-lightbox-btn',
            icon: 'fa-times',
            tip: 'Remove from lightbox'
        },
        star: {
            className: 'star-btn',
            icon: 'fa-star-o',
            tip: 'Star'
        },
        unstar: {
            className: 'unstar-btn',
            icon: 'fa-star',
            tip: 'Unstar'
        },
        addToCollection: {
            className: 'add-to-collection-btn',
            icon: 'fa-plus-square',
            tip: 'Add to Collection'
        },
        removeFromCollection: {
            className: 'remove-from-collection-btn',
            icon: 'fa-minus-square',
            tip: 'Remove from Collection'
        },
        download: {
            className: 'download-btn',
            icon: 'fa-download',
            tip: 'Download'
        },
        downloadPreview: {
            className: 'download-preview-btn',
            icon: 'fa-level-down',
            tip: 'Download preview'
        },
        reject: {
            className: 'reject-btn',
            icon: 'fa-minus-circle',
            tip: 'Reject'
        },
        unreject: {
            className: 'unreject-btn',
            icon: 'fa-plus-circle',
            tip: 'Unreject'
        },
        promote: {
            className: 'promote-btn',
            icon: 'fa-arrow-circle-up',
            tip: 'Promote'
        },
        demote: {
            className: 'demote-btn',
            icon: 'fa-arrow-circle-down',
            tip: 'Demote'
        },
        upload: {
            className: 'upload-btn',
            icon: 'fa-upload',
            tip: 'Upload file'
        },
        delete: {
            className: 'delete-btn',
            icon: 'fa-times',
            tip: 'Delete photo'
        },
        reward: {
            className: 'reward-btn',
            icon: 'fa-gift',
            tip: 'Reward photo'
        }
    }

    shouldComponentUpdate = (nextProps, nextState) => {
        return !(JSON.stringify(this.props.photo) === JSON.stringify(nextProps.photo));
    }

    render() {
        const { photo, purchasePhotosPolicy } = this.props;
        const { controls } = photo;

        const buttons = Object.keys(controls).map(control => {
            //Skip excluded buttons
            if (this.props.exclude.includes(control)) {
                return null;
            }

            //Dont render add to cart button if policy is blocked
            if (control === 'addToCart' && !purchasePhotosPolicy) {
                return null;
            }

            const controlConfig = controls[control];
            if (this.presets.hasOwnProperty(control) && (controlConfig.visible || (this.props.mode === 'preview' && controlConfig.visibleOnPreview))) {
                let trigger, href;
                const preset = this.presets[control];

                //Set default props
                let props = {
                    element: "button",
                    styleType: "dark",
                    className: `control-btn ${preset.className}`,
                    'data-tip': preset.tip,
                    size: "s"
                };


                //Set onClick trigger
                if (controlConfig.hasOwnProperty('trigger')) {
                    props.onClick = () => controlConfig.trigger(photo);
                } else if (preset.hasOwnProperty('trigger')) {
                    props.onClick = () => preset.trigger(photo);
                }

                //Set href
                if (controlConfig.hasOwnProperty('href') && controlConfig.href) {
                    props.element = 'anchor';
                    props.href = controlConfig.href;
                    props.target = controlConfig.target || '_blank';
                } else if (preset.hasOwnProperty('href')) {
                    props.element = 'anchor';
                    props.href = preset.href;
                    props.target = preset.target || '_blank';
                }

                //Set disabled state
                if (controlConfig.hasOwnProperty('disabled') && controlConfig.disabled) {
                    props.className += ` btn-disabled`;
                    props.onClick = null;
                    props.href = null;
                }

                return (
                    <Tooltip key={control} title={preset.tip}>
                        <Button {...props}>
                            <i className={`fa ${preset.icon}`}></i>
                        </Button>
                    </Tooltip>
                );
            } else {
                return (null);
            }
        });

        return (
            <div className="component-gallery-controls">
                {buttons}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/layout/GalleryControlsV2/index.js